(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["msj-conversion-picks"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change', (event) => {
  if (!event.target.matches('[data-msj-pick-variant]')) return;
  const input = event.target;
  const card = input.closest('.msj-pick');
  const image = card.querySelector('.msj-pick__image img');
  const pending = card.querySelector('.msj-pick__pending');
  card.querySelector('.msj-pick__price').textContent = input.dataset.price;
  card.querySelector('.msj-pick__chosen').textContent = input.dataset.label;
  card.querySelectorAll('a').forEach(link => { link.href = input.dataset.url; });
  if (image) {
    image.hidden = !input.dataset.image;
    if (input.dataset.image) {
      image.removeAttribute('srcset');
      image.src = input.dataset.image;
      image.alt = input.dataset.alt || input.dataset.label;
    }
  }
  pending.hidden = !!input.dataset.image;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["msj-footer"]) return;
  try {
    
document.addEventListener('click',event=>{if(event.target.closest('.msj-back-top'))window.scrollTo({top:0,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["msj-gift-card"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('msj-gift-picker')) {
  customElements.define('msj-gift-picker', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.addEventListener('change', (event) => {
        if (event.target.matches('input[data-gift-option]')) {
          this.querySelector('[data-gift-price]').textContent = event.target.dataset.price;
          const variant = this.querySelector('[data-gift-variant]');
          variant.value = event.target.value;
          variant.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["msj-home"] && !Shopify.designMode) return;
  try {
    
class MSJCoverCarousel extends HTMLElement {
  connectedCallback() {
    this.slides=Array.from(this.querySelectorAll('[data-cover-slide]'));
    this.dots=Array.from(this.querySelectorAll('[data-cover-index]'));
    this.pauseButton=this.querySelector('[data-cover-pause]');
    this.index=0;this.paused=matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.onClick=(event)=>{const dot=event.target.closest('[data-cover-index]');if(dot){this.show(Number(dot.dataset.coverIndex));this.stop();this.paused=true;this.updatePause();}else if(event.target.closest('[data-cover-pause]')){this.paused=!this.paused;this.updatePause();this.start();}};
    this.onEnter=()=>this.stop();this.onLeave=()=>this.start();
    this.onFocus=()=>this.stop();this.onBlur=()=>this.start();
    this.onVisibility=()=>document.hidden?this.stop():this.start();
    this.addEventListener('click',this.onClick);this.addEventListener('focusin',this.onFocus);this.addEventListener('focusout',this.onBlur);document.addEventListener('visibilitychange',this.onVisibility);
    this.updatePause();this.start();
  }
  disconnectedCallback(){this.stop();this.removeEventListener('click',this.onClick);this.removeEventListener('mouseenter',this.onEnter);this.removeEventListener('mouseleave',this.onLeave);this.removeEventListener('focusin',this.onFocus);this.removeEventListener('focusout',this.onBlur);document.removeEventListener('visibilitychange',this.onVisibility);}
  show(index){this.index=index;this.slides.forEach((slide,i)=>{const active=i===index;slide.classList.toggle('is-active',active);slide.setAttribute('aria-hidden',String(!active));slide.tabIndex=active?0:-1;});this.dots.forEach((dot,i)=>dot.setAttribute('aria-current',String(i===index)));}
  updatePause(){if(this.pauseButton){this.pauseButton.textContent=this.paused?this.dataset.play:this.dataset.pause;this.pauseButton.setAttribute('aria-pressed',String(this.paused));}}
  stop(){clearInterval(this.timer);this.timer=null;}
  start(){this.stop();if(this.slides.length>1&&!this.paused&&!document.hidden&&!this.contains(document.activeElement))this.timer=setInterval(()=>this.show((this.index+1)%this.slides.length),6500);}
}
if(!customElements.get('msj-cover-carousel'))customElements.define('msj-cover-carousel',MSJCoverCarousel);

  } catch(e) { console.error(e); }
})();
})();
